module.exports = __webpack_public_path__ + "img/a1d5872.png";